import styled, { css } from 'styled-components';
import { Modal } from '@material-ui/core';
import PrimitiveModal from '../../newComponents/Modal';

export const Container = styled.div<{
  asideIsOpen?: boolean;
  asideIsClosed?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-height: calc(100% - 64px);
  max-height: calc(100% - 64px);
  font-family: Sora, sans-serif;
  height: 100%;

  h1 {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-navy-blue);
    line-height: 35px;
    margin-bottom: 30px;
  }

  main {
    max-height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    flex: 2;
    overflow: hidden;

    .header {
      padding: 24px 24px 0px;

      @media (min-width: 768px) {
        padding: 30px 30px 0px;
      }
    }
  }

  @media (min-width: 600px) {
    ${(props) =>
      !props.asideIsOpen &&
      css`
        > aside {
          display: flex !important;

          .prev {
            display: none !important;
          }
        }

        > main {
          display: flex !important;

          .cart {
            display: none !important;
          }
      `}
    }
  }

  @media (min-width: 900px) {
    > aside {
      display: flex !important;

      .prev {
        display: none !important;
      }
    }

    > main {
      display: flex !important;

      .cart {
        display: none !important;
      }
    }
  }

  ${(props) =>
    props.asideIsClosed &&
    css`
      > aside {
        display: none;
      }

      > main {
        display: flex;
      }
    `}

  ${(props) =>
    !props.asideIsClosed &&
    css`
      > aside {
        max-width: 100%;
      }

      > main {
        display: none;
      }
    `}
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: var(--color-red-opacity-25);
    margin: none;
    svg {
      color: var(--color-red);
      font-size: 50px;
    }
  }
  h1 {
    color: var(--color-navy-blue);
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }
  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ContainerCoupon = styled.div<{ selectedCoupon?: boolean }>`
  display: flex;
  border: 2px solid var(--color-gray-900);
  justify-content: space-between;
  padding: 12px;
  align-items: center;
  border-radius: 5px;
  ${(p) =>
    p.selectedCoupon &&
    css`
      background-color: #329bfc1a;
      border-color: var(--color-blue);
    `}

  p {
    font-size: 13px;
  }

  button {
    font-size: 11px;
    font-weight: 400;
    padding: 11px;
    height: 36px;
  }

  button.remove {
    background-color: var(--color-red);

    :hover {
      background-color: var(--color-red);
    }
  }
`;

export const CustomModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  > div.body {
    min-width: 300px;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 20px;
      height: fit-content;
      background: #fff;
      border-radius: 4px;
      position: relative;
      gap: 8px;
      max-width: 350px;
      max-height: 90vh;

      form {
        display: flex;
        flex-direction: column;
        gap: 16px;
        max-height: 50vh;
        overflow: auto;
        min-height: 200px;
        width: 100%;

        scrollbar-width: thin;
        scrollbar-color: black transparent;

        &::-webkit-scrollbar {
          width: 3px;
          height: 3px;
        }

        &::-webkit-scrollbar-track {
          background: transparent;
          padding: 2px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #a1a1a1;
        }
      }
    }
  }
`;

export const CustomModalV2 = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: var(--color-alba-grandeza);
    margin-bottom: 10px;

    strong {
      color: var(--color-navy-blue);
      font-weight: 600;
      margin-top: 5px;
    }
  }
`;
